import Consents from './components/Consents.css';
import Checkbox from './components/Checkbox/Checkbox.css';

export default {
	Consents,
	Checkbox
};
